import MasonryComponent from './masonry';
new MasonryComponent;